<template>
  <div>
    <a href="https://api.whatsapp.com/send?phone=56975188819&text=Escr%C3%ADbenos%20tu%20consulta" target="_blank"><img src="../assets/svg/wsp_icon.svg" alt="" class="whatsapp-icon"></a>
  </div>
</template>

<script>

export default{
  name: "WhatsAppBtn",
  props: {

  }

}
</script>
